module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10272.abcf0f26.jpg";